<template>
        <div ref="codeBlock" style="position:relative">
            <pre><code v-if="code && asText" :class="`language-${language}`" style="background-color:initial" v-text="code"></code><code v-else-if="code" :class="`language-${language}`" style="background-color:initial" v-html="code"></code><code v-else :class="`language-${language}`" style="background-color:initial"><slot></slot></code></pre>
            <action-button icon="$copy" @click="copy" small fab color="accent" :tooltip="$t('common.code.copy')" absolute right top />
        </div>
</template>
<script>

import Prism from 'prismjs';
import He from 'he';

export default {
    name: 'CodeBlock',
    data() {
        return {
            txtStyle: { display: 'block' }
        };
    },
    props: {
        language: { type: String, default: 'javascript' },
        code: { type: String },
        asText: { type: Boolean }
    },
    computed: {
        decodedCode() {
            return this.asText ? this.code : He.decode(this.code);
        }
    },
    watch: {
    },
     mounted() {
        //console.debug('Prism!');
        Prism.highlightAllUnder(this.$refs.codeBlock);
    },
    updated() {
        //console.debug('code change detected');
        Prism.highlightAllUnder(this.$refs.codeBlock);
    },
    methods: {
        copy() {
           this.$copyText(this.decodedCode).then((e) => {
            this.$store.dispatch('ui/notify', { text: this.$t('common.code.copied')});
            console.debug(e);
            }, (e) => {
                this.$store.dispatch('ui/notify', { text: this.$t('common.code.error'), error: true });
                console.debug(e)
            })
        }
    }
}
</script>